import { createAction } from '@reduxjs/toolkit'
import { ICommitmentData } from 'legacy/lut/services/partner360/commitment/models/apiCommitmentData'
import { IApiCommitmentStatus } from 'legacy/lut/services/partner360/commitment/models/apiCommitmentStatus'

import { PARTNER360_COMMITMENT_NAMESPACE } from './constants'

export const commitmentItemsPending = createAction(
  `${PARTNER360_COMMITMENT_NAMESPACE}/commitmentItemsPending`
)

export const commitmentItemsRejected = createAction<string | undefined>(
  `${PARTNER360_COMMITMENT_NAMESPACE}/commitmentItemsRejected`
)

export const commitmentItemsFulfilled = createAction<ICommitmentData[]>(
  `${PARTNER360_COMMITMENT_NAMESPACE}/commitmentItemsFulfilled`
)

export const commitmentStatusesPending = createAction(
  `${PARTNER360_COMMITMENT_NAMESPACE}/commitmentStatusesPending`
)

export const commitmentStatusesRejected = createAction<string | undefined>(
  `${PARTNER360_COMMITMENT_NAMESPACE}/commitmentStatusesRejected`
)

export const commitmentStatusesFulfilled = createAction<IApiCommitmentStatus[]>(
  `${PARTNER360_COMMITMENT_NAMESPACE}/commitmentStatusesFulfilled`
)
